import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MuiSelect from '@mui/material/Select';
import { FormHelperText } from '@mui/material';
import getSxAttributes from 'helpers/getSxAttributes';

const Select = ({
  classes,
  disabled,
  error,
  id,
  label,
  margin,
  name,
  options,
  placeholder,
  testId,
  required,
  disablePlaceholder,
  ...props
}) => {
  let displayedPlaceholder;
  if (disablePlaceholder) {
    displayedPlaceholder = null;
  } else if (placeholder) {
    displayedPlaceholder = (
      <option value="" disabled>
        {placeholder}
      </option>
    );
  } else {
    displayedPlaceholder = <option value="" />;
  }

  return (
    <FormControl
      disabled={disabled}
      margin={margin}
      sx={(theme) => ({ width: '100%', ...getSxAttributes(theme, props.sx) })}
      variant="outlined"
      error={!!error}
    >
      {label && (
        <InputLabel htmlFor={id} required={required}>
          {label}
        </InputLabel>
      )}
      <MuiSelect
        label={label}
        inputProps={{
          name,
          id,
          'data-testid': testId,
          'aria-label': name,
        }}
        native
        {...props}
      >
        {displayedPlaceholder}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </MuiSelect>
      {error && (
        <FormHelperText>
          <b>{error}</b>
        </FormHelperText>
      )}
    </FormControl>
  );
};

Select.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  margin: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  placeholder: PropTypes.string,
  testId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.bool,
  disablePlaceholder: PropTypes.bool,
};

Select.defaultProps = {
  disabled: false,
  error: null,
  options: [],
  placeholder: null,
  margin: 'normal',
  testId: null,
  value: '',
  required: false,
  disablePlaceholder: false,
  label: null,
};

export default Select;
